function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "location-2",
  "data-name": "location",
  d: "M0,4.743C0,1.9,1.8,0,4.5,0A4.641,4.641,0,0,1,9,4.743q0,2.172-3.775,5.936a1.07,1.07,0,0,1-1.489.038Q0,7.336,0,4.743Zm4.5.949A1.542,1.542,0,0,0,6,4.111,1.542,1.542,0,0,0,4.5,2.53,1.542,1.542,0,0,0,3,4.111,1.542,1.542,0,0,0,4.5,5.692Z",
  transform: "translate(0 0)",
  fill: "#7d9ef1"
});

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "location",
    width: 12,
    height: 14,
    viewBox: "0 0 9 11",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.d1f5e620.svg";
export { ForwardRef as ReactComponent };